var map = {
	"./add.svg": "c2a3",
	"./close-h.svg": "7ec0",
	"./close-h1.svg": "f40c",
	"./close-m.svg": "bc13",
	"./close.svg": "7710",
	"./close1.svg": "0a5c",
	"./close_new.svg": "923e",
	"./colse-h.svg": "bfbb",
	"./completed.svg": "2e64",
	"./copy-link-h.svg": "18c8",
	"./copy-link.svg": "4f49",
	"./delect-h.svg": "85f8",
	"./delect.svg": "5600",
	"./delete-h.svg": "72b9",
	"./delete.svg": "59a1",
	"./down-h.svg": "d2dc",
	"./down.svg": "d681",
	"./error.svg": "b1b9",
	"./failed.svg": "0199",
	"./history-s.svg": "0903",
	"./history.svg": "c023",
	"./icon.svg": "9d91",
	"./img-change.svg": "5103",
	"./list-close.svg": "42f7",
	"./list-open.svg": "6954",
	"./load.svg": "a8b5",
	"./login-s.svg": "1d6f",
	"./login.svg": "09b4",
	"./mobile-add copy.svg": "9a2d",
	"./mobile-add.svg": "ce43",
	"./no-history.svg": "f80f",
	"./open-h.svg": "7831",
	"./open.svg": "ace4",
	"./pic_empty.svg": "bad2",
	"./pic_waring.svg": "6486",
	"./previous.svg": "252b",
	"./processing-b.svg": "3ce1",
	"./processing.svg": "7a23",
	"./return.svg": "3488",
	"./select.svg": "064a",
	"./semi-select.svg": "545b",
	"./success.svg": "a8cf",
	"./tax-included.svg": "b16f",
	"./tip.svg": "f943",
	"./unselect.svg": "ab9d",
	"./upgrade-s.svg": "686d",
	"./upgrade.svg": "b33e",
	"./upgrade2.svg": "ae22",
	"./upload-b.svg": "879a",
	"./upload.svg": "9d82",
	"./uploading.svg": "42da",
	"./waiting-b.svg": "2d43",
	"./waiting.svg": "befd",
	"./yes.svg": "8d65"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";